<template>
  <div class="pb-3">
    <section id="api_statistics_task_response" class="pt-2">
      <h4 class="pb-2">Время ответа по задаче</h4>
      <div class="nav-api">
        <ul class="nav nav-tabs nav-tabs-clean">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="post">POST</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">{{ url }}/{{ method }}/:id/response</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>id</td>
                  <td>целое число</td>
                  <td>обязательный параметр</td>
                  <td>ID задачи</td>
                </tr>
                <tr>
                  <td>period</td>
                  <td>строка</td>
                  <td>обязательное поле, может содержать значения hour, day, week и month</td>
                  <td>период статистики (hour - час, day - день, week - неделя, month - месяц)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="example">Пример</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div
            class="tab-pane fade show active">curl -X POST -H "Authorization: Bearer {{ token }}" -d "period=hour" {{ url }}/{{ method }}/1/response</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="success">Ответ</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">
            <pre class="mb-0">HTTP/1.1 200 OK
{
  "status": "success",
  "data": {
    "16:10": 110.84,
    "16:00": 123.86,
    "15:50": 120.87,
    "15:40": 128.85,
    "15:30": 130.35,
    "15:20": 132.13,
    "15:10": 117.96
  }
}</pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token', 'user'],
    data() {
      return {
        method: 'v1/statistics/tasks'
      }
    }
  }
</script>